import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppObservable {

  constructor() { }
  public language = new BehaviorSubject('es');
  public davosHelp = new BehaviorSubject(false);

  public isLogged = new BehaviorSubject(false);
  public userLogged = new BehaviorSubject(null);
  public getAuth = new BehaviorSubject(null);

  public loadingSpinner = new BehaviorSubject(false);

  public modalActiveList = new BehaviorSubject([]);

  public currentCompanyModel = new BehaviorSubject(null);
  public employeeList = new BehaviorSubject(null);

  public containerPositionScrollY = new BehaviorSubject(null);

  // HomeEmployee
  public loggedEmployee = new BehaviorSubject(null);
  public loggedEmployeeCompanyList = new BehaviorSubject([]);
  public activeBreakEmployee = new BehaviorSubject([]);
  public committeeVoteEmployeeList = new BehaviorSubject([]);
  public activeBreakML = new BehaviorSubject([]);

  public showPDF = new BehaviorSubject(null);

  public signalingLog = new BehaviorSubject([]);

  public subscribedCompany = new BehaviorSubject(null);
}
